export const PORTO_RECAPTCHA_V3_SITE_KEY =
  typeof window !== 'undefined'
    ? window?.env?.SENTRY_ENVIRONMENT === 'production'
      ? '6LdiE84qAAAAANLENEhXTNjQZrYY0bxET7od6os3'
      : window?.env?.SENTRY_ENVIRONMENT === 'staging'
        ? '6LdGcr4qAAAAALjttziHGK9dGRefM_dm0N0NzwkS'
        : '6Le_Y74qAAAAAIXH73Hr3xTnm2VL4cJiNv1DErH9'
    : '';

enum SentryEnvironments {
  PRODUCTION = 'production',
  STAGING = 'staging',
  DEVELOPMENT = 'development',
  RELEASE = 'release',
}

export const getMixpanelOptions = () => {
  switch (typeof window !== 'undefined' && window?.env?.SENTRY_ENVIRONMENT) {
    case SentryEnvironments.STAGING:
      return {
        token: '83f64d39c6828bf0b921fa8dc4f27312',
      };
    case SentryEnvironments.PRODUCTION:
      return {
        token: '0d9567b544ed5705e923bf2950890e57',
      };
    default:
      return {
        token: '1f8ae71746105a5c165c085af4e2a0fd',
      };
  }
};

export function getLaunchDarklyEnvOptions() {
  const sentryEnvironment =
    typeof window !== 'undefined' ? window?.env?.SENTRY_ENVIRONMENT : undefined;

  switch (sentryEnvironment) {
    case SentryEnvironments.STAGING:
      return {
        clientSideId: '6826124fa4f18b092efed6fc',
      };
    case SentryEnvironments.PRODUCTION:
      return {
        clientSideId: '681e6ab84dbfa60ddf1f3a43',
      };
    default:
      return {
        clientSideId: '68261247a4f18b092efed6b0',
      };
  }
}

const CLIENT_DASHBOARD_LOGIN_URLS = {
  [SentryEnvironments.DEVELOPMENT]:
    'https://clientdashboard.anchorage-development.com',
  [SentryEnvironments.STAGING]: 'https://clientdashboard.anchorage-staging.com',
  [SentryEnvironments.PRODUCTION]: 'https://anchoragelogin.com',
} as const;

export const getClientDashboardLoginLink = () => {
  switch (window?.env?.SENTRY_ENVIRONMENT) {
    case SentryEnvironments.DEVELOPMENT:
      return CLIENT_DASHBOARD_LOGIN_URLS[SentryEnvironments.DEVELOPMENT];
    case SentryEnvironments.STAGING:
      return CLIENT_DASHBOARD_LOGIN_URLS[SentryEnvironments.STAGING];
    case SentryEnvironments.PRODUCTION:
    default:
      return CLIENT_DASHBOARD_LOGIN_URLS[SentryEnvironments.PRODUCTION];
  }
};
